import { render, staticRenderFns } from "./ImportHorseMicroship.vue?vue&type=template&id=74810714&"
import script from "./ImportHorseMicroship.vue?vue&type=script&lang=js&"
export * from "./ImportHorseMicroship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports